import classnames from 'classnames';
import { INFERRED_TYPE_ENUM } from 'constants/chart-channels';
import styles from './grid.less';

/**
 * Given an inferred type, return an object containing the icons configuration for the column definition.
 *
 * @param {String} inferredType - the inferred type of the channel.
 * @returns {Obbject}
 **/
const getColumnIconsForInferredType = inferredType => {
  switch (inferredType) {
    case INFERRED_TYPE_ENUM.NUMBER:
    case INFERRED_TYPE_ENUM.DATE:
      return {
        icons: {
          sortAscending: `<i class="${classnames(
            styles['grid-icon'],
            styles['grid-icon--sort-numeric-asc']
          )}" />`,
          sortDescending: `<i class="${classnames(
            styles['grid-icon'],
            styles['grid-icon--sort-numeric-desc']
          )}" />`,
        },
      };

    case INFERRED_TYPE_ENUM.STRING:
      return {
        icons: {
          sortAscending: `<i class="${classnames(
            styles['grid-icon'],
            styles['grid-icon--sort-alpha-asc']
          )}" />`,
          sortDescending: `<i class="${classnames(
            styles['grid-icon'],
            styles['grid-icon--sort-alpha-desc']
          )}" />`,
        },
      };

    default:
      return {};
  }
};

export default getColumnIconsForInferredType;
export { getColumnIconsForInferredType };
